import { lazyWithPreload } from 'helpers/lazyWithPreload'

export const Sugar = lazyWithPreload(() => import('./Sugar'))
export const LikeChatSugar = lazyWithPreload(() => import('./LikeChatSugar'))
